/** How far down the view a section must reach to count as the one being played (spec: 30%). */
const readingLine = 0.3

/**
 * The section the performer is at: the innermost `[data-performance-section]` crossing 30% of the
 * scroll view, else the next one below it. Read when asked (N, "+ Jot"), so scrolling costs nothing.
 */
export const sectionInView = (scrollEl: HTMLElement | null): string | null => {
  if (!scrollEl) {
    return null
  }
  const view = scrollEl.getBoundingClientRect()
  const line = view.top + view.height * readingLine
  const sections = Array.from(scrollEl.querySelectorAll<HTMLElement>('[data-performance-section]'))
  const crossing = sections.filter(el => {
    const rect = el.getBoundingClientRect()
    return rect.top <= line && rect.bottom > line
  })
  // Document order puts a nested section after the section around it
  const current = crossing.at(-1) ?? sections.find(el => el.getBoundingClientRect().top > line)
  return current?.dataset.performanceSection ?? null
}
